import AccountDetails from '../entities/AccountDetails';
import AccountEntity from '../entities/AccountEntity';
import AccountBalance from '../entities/AccountBalance';
import ErrorHandler from '../entities/ErrorHandler';
import moment from 'moment';
import _ from 'lodash';

export default class AccountParser {
  parseAccountListResponse(response) {
    const _accountList = [];
    let _accountBal = [];
    let counter = 1;

    response.accounts.map((account) => {
      const displayName = _.get(account, 'metadata.display_name', '');
      const accountName = _.get(account, 'metadata.account_name', '');
      const displayOrder = _.get(account, 'metadata.display_order', 0);
      const productName = _.get(account, 'product.name', '');

      const accountObject = new AccountEntity();
      accountObject.id = account.id;
      accountObject.type = account.type;
      accountObject.number = account.number;
      accountObject.accountName = accountName;
      const number = _.split(account.number, '-');
      accountObject.sortCode = number[0];
      accountObject.accountNumber = number[1];
      accountObject.product = account.product;
      accountObject.actionsAvailable = account.actions_available;
      accountObject.bank_id = account.bank_id;
      accountObject.metadata = account.metadata;
      accountObject.role = account.role;
      accountObject.displayName = _.isEmpty(displayName)
        ? productName
        : displayName;
      accountObject.display_order = displayOrder === 0 ? counter : displayOrder;
      counter = counter + 1;
      if (!accountObject.actionsAvailable['/account/read/limited']) {
        _.map(account.balances, (balance) => {
          const accountBalance = new AccountBalance();
          accountBalance.type = balance.type;
          accountBalance.amount = _.get(balance, 'amount.value');
          accountBalance.currency = _.get(balance, 'amount.currency', 'GBP');
          _accountBal.push(accountBalance);
        });

        accountObject.balances = _accountBal;
        _accountBal = [];
      }
      accountObject.currency = _.get(
        _.head(account.balances),
        'amount.currency',
        'GBP'
      );
      if (_.has(account, 'bacs')) {
        accountObject.bacs = account.bacs;
      }
      _accountList.push(accountObject);
      return true;
    });
    return _.sortBy(_accountList, ['display_order']);
  }

  parseNumberOfAccounts(response) {
    return response.total_number_of_accounts;
  }

  parseAccountDetailResponse(response) {
    const accountDetails = new AccountDetails();
    accountDetails.id = response.id;
    const _accountBal = [];
    if (!response.actions_available['/account/read/limited']) {
      _.map(response.balances, (balance) => {
        const accountBalance = new AccountBalance();
        accountBalance.type = balance.type;
        accountBalance.amount = balance.amount.value;
        accountBalance.currency = balance.amount.currency;
        _accountBal.push(accountBalance);
      });
      accountDetails.balances = _accountBal;
    }
    if (response.bic) {
      accountDetails.bic = response.bic;
    }
    if (response.iban) {
      accountDetails.iban = response.iban;
    }
    if (typeof response.interest_rate === 'number') {
      accountDetails.interest_rate = response.interest_rate;
    }
    if (response.limits) {
      switch (response.limits[0].type) {
        case 'overdraft':
          accountDetails.overDraft = response.limits[0].amount.value;
          break;
        case 'credit':
          accountDetails.creditLimit = response.limits[0].amount.value;
          break;
        default:
          break;
      }
    }
    if (response.type === 'credit_card') {
      if (_.isEmpty(response.statements)) {
        accountDetails.statementFlag = false;
      } else {
        accountDetails.statementFlag = true;
        accountDetails.lastStatementDate = moment(
          response.statements.last.balance.at
        ).format('DD MMM YY');
        accountDetails.lastStatementBalance =
          response.statements.last.balance.amount.value;
        accountDetails.minimumPayment =
          response.statements.last.payment.minimum_amount.value;
        accountDetails.minimumPaymentDate = moment(
          response.statements.last.payment.when
        ).format('DD MMM YY');
      }
    }
    return accountDetails;
  }

  parseListErrorHandler(error) {
    const accountListError = new ErrorHandler();
    accountListError.id = error.error.id;
    accountListError.code = error.error.code;
    accountListError.quoteId = error.error.quoteId;
    accountListError.message = error.error.message;

    return accountListError;
  }

  parseFromFavouriteAccount(account) {
    const accountObject = new AccountEntity();
    accountObject.id = account.id;
    accountObject.type = account.type;
    accountObject.number = account.number;
    accountObject.sortCode = account.sortCode;
    accountObject.accountNumber = account.accountNumber;
    accountObject.accountName = account.accountName;
    accountObject.product = {
      ...account.product,
    };
    accountObject.actionsAvailable = {
      ...account.actionsAvailable,
    };
    accountObject.bank_id = account.bank_id;
    accountObject.metadata = account.metadata;
    accountObject.displayName = account.displayName;
    accountObject.display_order = account.display_order;
    const formattedBalances = [];
    if (!accountObject.actionsAvailable['/account/read/limited']) {
      _.map(account.balances, (balance) => {
        const accountBalance = new AccountBalance();
        accountBalance.type = balance.type;
        accountBalance.amount = _.get(balance, 'amount.value', 0);
        accountBalance.currency = _.get(balance, 'amount.currency', 'GBP');
        formattedBalances.push(accountBalance);
      });
      accountObject.balances = formattedBalances;
      accountObject.accountDetails = { balance: formattedBalances };
    }
    if (account.bacs) {
      accountObject.bacs = account.bacs;
    }
    return accountObject;
  }
}
